const clientsRoutes = [
    {
        path: '/clients',
        redirect: '/clients/dashboard',
        component: () => import('@/views/Clients'),
        meta: { requiresAuth: true, checkUserRole: true },
        children: [
            {
                path: 'dashboard',
                name: 'Clients Dashboard',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Clients'),
            },

            // webshops
            {
                path: 'webshops',
                name: 'Clients Webshops',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Webshops'),
            },
            {
                path: 'webshops/add',
                name: 'Clients Webshops Add',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Webshops/AddWebshop'),
            },
            {
                path: 'webshops/:id/edit',
                name: 'Clients Webshops Edit',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Webshops/EditWebshop'),
            },

            // feeds
            {
                path: 'feeds',
                name: 'Clients Feeds',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Feeds'),
            },
            {
                path: 'feeds/add',
                name: 'Clients Feeds Add',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Feeds/AddFeed'),
            },
            {
                path: 'feeds/:id/edit',
                name: 'Clients Feeds Edit',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Feeds/EditFeed'),
            },
            {
                path: 'feeds/:id/combine',
                name: 'Clients Feeds Combine',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Feeds/Combine/CombineFeed'),
            },

            // connections
            {
                path: 'connections',
                name: 'Clients Connections',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections'),
            },
            {
                path: 'connections/add',
                name: 'Clients Connections Add',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/AddConnection'),
            },
            {
                path: 'connections/:id/edit',
                name: 'Clients Connections Edit',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/EditConnection'),
            },

            {
                path: 'connections/:id/categories',
                name: 'Clients Connections Categories',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Categories/CombineCategories'),
            },

            {
                path: 'connections/:id/brands',
                name: 'Clients Connections Brands',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Brands/CombineBrands'),
            },

            {
                path: 'connections/:id/attributes',
                name: 'Clients Connections Attributes',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Attributes/Attributes'),
            },

            {
                path: 'connections/:id/attributes/add',
                name: 'Clients Connections Attributes Add',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Attributes/AddAttribute'),
            },

            {
                path: 'connections/:id/attributes/edit/:attribute_id',
                name: 'Clients Connections Attributes Edit',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Attributes/EditAttribute'),
            },

            {
                path: 'connections/:id/pricing',
                name: 'Clients Connections Pricing',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Pricing/Pricing'),
            },

            {
                path: 'connections/:id/pricing/add',
                name: 'Clients Connections Pricing Add',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Pricing/AddPricing'),
            },

            {
                path: 'connections/:id/pricing/edit/:pricing_id',
                name: 'Clients Connections Pricing Edit',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Pricing/EditPricing'),
            },

            {
                path: 'connections/:id/customer_groups',
                name: 'Clients Connections Customer Groups',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/CustomerGroups/CustomerGroups'),
            },

            {
                path: 'connections/:id/customer_groups/add',
                name: 'Clients Connections Customer Groups Add',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/CustomerGroups/AddCustomerGroup'),
            },

            {
                path: 'connections/:id/customer_groups/edit/:customerGroupId',
                name: 'Clients Connections Customer Groups Edit',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/CustomerGroups/EditCustomerGroup'),
            },

            {
                path: 'connections/:id/products',
                name: 'Clients Connections Products',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Products/Products'),
            },

            {
                path: 'connections/:id/products/logs',
                name: 'Clients Connections Products Logs',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Products/ProductSyncLog'),
            },

            {
                path: 'connections/:id/products/:productId/edit',
                name: 'Clients Connections Products Edit',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Products/EditProduct'),
            },

            {
                path: 'connections/:id/languages',
                name: 'Clients Connections Languages',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Languages/Languages'),
            },
            {
                path: 'connections/:id/languages/add',
                name: 'Clients Connections Languages Add',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Languages/AddLanguage'),
            },
            {
                path: 'connections/:id/languages/:languageId',
                name: 'Clients Connections Languages Edit',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Connections/Languages/EditLanguage'),
            },

            {
                path: 'company',
                name: 'Client Company',
                meta: { checkUserSubbed: true },
                component: () => import('@/views/Clients/Company/MyCompany'),
            },

            {
                path: 'subscription',
                name: 'Client Company Subscription',
                meta: { checkUserSubbed: false },
                component: () => import('@/views/Clients/Company/Subscription'),
            },
        ],
    },
];

export default clientsRoutes;
